export default __webpack_public_path__ + "static/slime-1dbc3aa9ed4e82c06147a2fa980bbd6e.mp4";